import React, {useEffect, useState} from 'react';
import {TableCell, TableRow} from "../../../shadCn/components/ui/table";
import HeaderModifier from "../HeaderModifier";
import Sort from "./Sort";
import NoImage from "../../../resources/icon/noImage.png";
import EmptyData from "../../../resources/icon/empty-data.png";
import {useNavigate} from "react-router-dom";
import {isEmpty, formatSimmsGridCell, formatSimmsDateTime} from "../../commonmethod/CommonMethod";
import {RatedStart} from "../../../packages/serviceRequest/serviceRequest/subpage/ServiceStarRating";

/**
 * 모든 화면출력은 TableMovable 을 호출하는 컴포넌트의 header 설정에 의한다.
 * header의 옵션
 *  필수      옵션명              설명
 *           minWidth           최소넓이 (px단위)
 *           width              넓이 (px단위)
 *           type               데이터 타입
 *   o       field              어떤 (필드의)데이터를 출력할지
 *           label              값 앞에 어떤 라벨을 붙여줄지 ex ( label : "등록일 : ", field:"createAt" ... )
 *           renderer           사용자 버튼등 <jsx 요소 />
 */

/** type
 * image : 이미지
 * dateArray : 날짜가 배열로 들어올 때.
 * */

function TableMovable({ header, data, checked, page, url, handleSortChange, height}) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE;
    const [copiedHeader, setCopiedHeader] = useState(header);
    const [idxArray, setIdxArray] = useState(Array.from({ length: header.length }, (_, index) => index.toString()));
    const [exArray, setExArray] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const navigate = useNavigate();

    const [isHeaderChecked, setIsHeaderChecked] = useState(false);

    useEffect(() => {
        const newCopiedHeader = idxArray.map(index => header[index]);
        setCopiedHeader(newCopiedHeader);
    }, [idxArray, header]);

    useEffect(() => {
        updateHeaderChkbox();
    }, [data, checked]);

    useEffect(() => {
        if (checked && checked.required) {
            const ids = data.map(item => item.id);
            checked.setChecked([...ids]);
        }
    }, [data]);

    const handleHeaderCheckboxClick = () => {
        setIsHeaderChecked(prev => !prev);
        if (!isHeaderChecked) {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => [...new Set([...prevItems, ...currentPageIds])]);
        } else {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => prevItems.filter((item) => !currentPageIds.includes(item)));
        }
    };

    const handleCheckboxClick = (value) => {
        const isChecked = checked.checked && checked.checked.includes(value);
        if (isChecked) {
            checked.setChecked((prevItems) => prevItems.filter((item) => item !== value));
        } else {
            checked.setChecked((prevItems) => [...prevItems, value]);
        }
        updateHeaderChkbox();
    };

    function updateHeaderChkbox() {
        if (checked && data && data.length > 0) {
            const allChecked = data.every((item) => checked.checked.includes(item.id));
            setIsHeaderChecked(allChecked);
        } else {
            setIsHeaderChecked(false);
        }
    }

    const goTo = (id, linkUrl) => {
        if (linkUrl) {
            navigate(`${linkUrl}`);
            return;
        }
        if(isEmpty(url)) return
        navigate(`${url}/${id}`);
    };

    function getNestedValue(obj, path, short) {
        return path.split('.').reduce((acc, part) => {
            if (Array.isArray(acc)) {
                if (short) {
                    const [firstCount, unit] = short;
                    const first = acc.slice(0, firstCount).map(item => item[part]).join(', ');
                    const count = acc.length - firstCount;
                    return count > 0 ? `${first} 외 ${count}${unit}` : first;
                }
                return acc.map(item => item[part]).join(', ');
            }
            return acc && acc[part];
        }, obj);
    }

    function getInnerObject(obj, path, short) {
        const objName = path.split('.')[0];
        return obj[objName];
    }

    const moveByLink = (item, path, linkId, short) => {
        if (path && linkId) {
            navigate(`${path}/${getNestedValue(item, linkId, short)}`);
        } else if (path) {
            navigate(`${getNestedValue(item, path, short)}`);
        }
    }

    return (
        <div>
            <div className="mb-2 relative">
                <span className="totalElements" onClick={() => console.log(idxArray)}>
                    총 {page.totalElements} 건
                </span>
                {/*<div className="inline-block float-right" onClick={() => setFilterOpen(!filterOpen)}>*/}
                {/*    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"*/}
                {/*         stroke="currentColor" className="w-6 h-6 inline-block">*/}
                {/*        <path strokeLinecap="round" strokeLinejoin="round"*/}
                {/*              d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"/>*/}
                {/*    </svg>*/}
                {/*</div>*/}
            </div>

            <div className={"table-border-top relative"}>
                {/*{idxArray && filterOpen &&*/}
                {/*    <HeaderModifier copiedHeader={copiedHeader} exArray={exArray} setExArray={setExArray}*/}
                {/*                    idxArray={idxArray} setIdxArray={setIdxArray} setFilterOpen={setFilterOpen}/>*/}
                {/*}*/}
                <div className={`relative w-full overflow-auto table-border bg-[var(--even-background)] ${height ? '' : "height-max"}`} style={height ?? {}}>
                    <table className="common-table w-full caption-bottom">
                        <thead className="t-sticky ">
                        <tr className="table-head-row">
                            {checked &&
                                <th style={{ width: '40px', maxWidth: '40px' }}
                                    className="text-center chk-box-col border-1-deep-gray-not-left">
                                    <input
                                        checked={isHeaderChecked}
                                        onChange={handleHeaderCheckboxClick}
                                        type="checkbox"/>
                                </th>
                            }
                            <th className="common-table-th text-center " style={{ width: '60px' }}>No.</th>

                            {copiedHeader.map((th, idx) => {
                                const styles = {};
                                if (th && th.minWidth) {
                                    styles.minWidth = th.minWidth + `px`;
                                }
                                if (th && th.width) {
                                    styles.width = th.width + `px`;
                                }
                                if (th && !exArray.includes(th.field)) {
                                    return (
                                        <th className="common-table-th text-indent text-left" key={idx} style={styles}>
                                            {th.name}
                                            {/*{th.type !== 'image' &&*/}
                                            {/*    <Sort handleSortChange={handleSortChange} pageInfo={page} target={Array.isArray(th.field) ? th.field[0]: th.field}/>*/}
                                            {/*}*/}
                                        </th>
                                    );
                                }
                                return null;
                            })}
                        </tr>
                        </thead>

                        <tbody className="table-body">
                        {data && data.length > 0 ? (data.map((item, rowIndex) => (
                            <tr key={rowIndex} className="cursor-pointer">

                                {checked &&
                                <td className="text-center border-1-deep-gray-not-left chk-box-col" onClick={(e) => {
                                    e.stopPropagation();
                                    handleCheckboxClick(item.id);
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={checked.checked && checked.checked.includes(item.id)}
                                        readOnly
                                        // onChange={() => handleCheckboxClick(item.id)}
                                    />
                                </td>
                                }
                                <td className="border-1-deep-gray text-center h-[30px]">
                                    {page.totalElements - ( (page.currentPage)* page.size + rowIndex) }
                                </td>

                                {copiedHeader.map((th, colIndex) => (
                                    !exArray.includes(th?.field) && (
                                        <td className="text-indent border-1-deep-gray truncate"
                                            key={colIndex}
                                            onClick={(e) => {
                                                if(th.block) {
                                                    e.stopPropagation();
                                                }else{
                                                    if (th.type === 'link') return;
                                                    th.button || goTo(item.id, item['linkUrl']);
                                                }
                                            }}
                                        >

                                        {th && th.type === "image" &&
                                            <div className="w-[30px] h-[30px] p-[2px]">
                                                {item[th.field] ?
                                                    <img className="w-[26px] ml-[4px] block"
                                                         src={`${IMG_BASE + item[th.field][0].path}${item[th.field][0].thumbnail ? 'thumb_' : ''}${item[th.field][0].uploadName}`}/>
                                                    :
                                                    <img className="w-[26px] ml-[4px] align-middle" src={NoImage}
                                                         alt="이미지 설명"/>
                                                }
                                            </div>
                                        }

                                        {th && !th.renderer && !th.type &&
                                            formatSimmsGridCell(th.field, getNestedValue(item, th.field, th.short))
                                        }

                                        {th && th.type === "dateArray" && th.field.map((each, index) => {
                                            const label = copiedHeader[colIndex].label[index] ?? "";
                                            const raw = item[th.field[index]];
                                            const text = typeof raw === "string" ? formatSimmsDateTime(raw) : "";
                                            return (
                                                <p key={index}> {label + text}</p>
                                            )
                                        })}

                                        {th && th.type === "objectArray" && th.field.map((each, index) => {
                                            const label = copiedHeader[colIndex].label[index] ?? "";
                                            const value = getNestedValue(item, th.field[index], th.short) ?? "";
                                            return (
                                                <p key={index}> {`${label} ${value}`}</p>
                                            )
                                        })}

                                        {th && th.renderer &&
                                            <th.renderer keys={item.id} data={getInnerObject(item, th.field, th.short)} item={item}/>
                                        }

                                        {th && th.type === "link" &&
                                            <>
                                                <p className={`hover:underline`}
                                                   onClick={() => moveByLink(item, th.path, th.linkId, th.short)}
                                                >
                                                    {th.field ? getNestedValue(item, th.field, th.short) : "바로가기"}
                                                </p>
                                            </>
                                        }
                                        {th && th.type === 'feedback' &&
                                            <>
                                                {item[th.field] !== 0 &&
                                                    <RatedStart
                                                        defaultValue={item[th.field]}
                                                        className={"justify-center"}
                                                    />
                                                }
                                            </>
                                        }
                                    </td>
                                )))}
                            </tr>
                        ))) : (
                            <TableRow className="common-table-nodata-tr h-[492px]">
                                <TableCell className="table-no-data text-center" colSpan={checked ? copiedHeader.length + 2 : copiedHeader.length + 1}>
                                    <img src={EmptyData} className="w-[70px] m-auto mb-3"/>
                                    <span className="">내역이 없습니다.</span>
                                </TableCell>
                            </TableRow>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default TableMovable;
